module.exports = __webpack_public_path__ + "img/icon_white-lock.bdfc35f6.svg";